<template>
  <div>
    <iframe
      width="100%"
      height="650px"
      :src="heatmapUrl"
      frameborder="0"
      style="border: 0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as accountTypes from "@/modules/account/store/types";
import { isFeOrAboveRole, isFouderOrSupportRole } from "@/constants/auth";

export default {
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    heatmapUrl() {
      if(isFouderOrSupportRole(this.user?.user_role_id)){
        return `https://lookerstudio.google.com/embed/reporting/3be7641d-a41a-4233-8f1b-93034b1d0b1b/page/CYFdE`
      } else if(isFeOrAboveRole(this.user?.user_role_id)){
        return `https://lookerstudio.google.com/embed/reporting/3be7641d-a41a-4233-8f1b-93034b1d0b1b/page/p_4x8ohvezwd?params=%7B%22df25%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.user.digital_franchise_id}%22%7D`
      }
      return `https://lookerstudio.google.com/embed/reporting/b71a67c0-f4c6-40a5-85b3-8fa9f1000c74/page/CYFdE/edit?params=%7B%22df11%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.user.appify_consultant_id}%22%7D`
    }
  },
}

</script>
